// import external dependencies
import "@babel/polyfill";
import 'jquery';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

import './calculator.js'

import { config, library, dom } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';

config.searchPseudoElements = false;
library.add(fas, fab, far);

dom.watch();

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// Custom toggle for accordions to allow multiple open
$('.accordion-header.toggle').click(function() {
  if ($(this).parent().hasClass('is-active')) {
    $(this).parent().removeClass('is-active');
  } else {
    $(this).parent().addClass('is-active');
  }
});

// Validate URLs
function isUrl(str) {
  const regex = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;

  if (regex.test(str)) {
    return true;
  } else {
    return false;
  }
}

// Mobile 2nd level select list menu
$('.section-menu-wrap').find('select').on('change', function() {
  var url = $(this).attr('value');

  if (isUrl(url)) {
    window.location.href = url;
  }
});

// FAQ search
$('#faq-search-reset').click(function() {
  $('.faq-search-input').val('');
  $('.faq-search-input').trigger('input');
  $('.faq-search').removeClass('has-reset');
});

$('.faq-search-input').on('propertychange input', function (e) {
  var valueChanged = false;

  if (e.type == 'propertychange') {
    valueChanged = e.originalEvent.propertyName=='value';
  } else {
    valueChanged = true;
  }

  if (valueChanged) {
    var val = $('.faq-search-input').val().toLowerCase();
    var resultCount = 0;

    if (val.length > 0) {
      $('.accordions-wrap').addClass('search-results');
      $('.result-counter').removeClass('is-hidden');
      $('.faq-search').addClass('has-reset');
    } else {
      $('.accordions-wrap').removeClass('search-results');
      $('.result-counter').addClass('is-hidden');
      $('.faq-search').removeClass('has-reset');
    }

    $('.accordion-header').each(function() {
      var text = $(this).text().toLowerCase();
      var search = text.search(val);
      if (search < 0) {
        $(this).parent().addClass('is-hidden');
      } else {
        $(this).parent().removeClass('is-hidden');
        var searchText = $(this).text();
        $(this).html(searchText.replace(val, '<mark>'+ val +'</mark>'));
        resultCount++;
      }
    });

    if (resultCount > 0) {
      $('.search-results').removeClass('no-results');
    } else {
      $('.search-results').addClass('no-results');
    }

    $('.result-counter > .counter').text(resultCount);
  }
});

$('.faq-search-input').keypress(
  function(event){
    if (event.which == '13') {
      event.preventDefault();
    }
});



// WEBPACK FOOTER //
// ./scripts/main.js